<div> 
   <!-- Table -->
    <div id="print-preview-lender-ranking">
        <div id="lenderRankingTable" class="submittedFilesTable">
          <fm-table #lenderrankingtbl [columns]="lenderRankingTableColumns" [value]="lenderRankingTableDisplay"
            sortMode="single" [loadingIcon]="true" [paginator]="true" [rows]="30" [rowsPerPageOptions]="[25,30,50,75,100,125,150,200]"
            [enableTableEntryTotal]="true" tableEntryTotalPosition="bottomLeft" paginatorPosition="bottomRight">
            <ng-template fmTemplate="caption">
              <div style="text-align: left">
                <input placeholder="Search" style="width:auto" fmTextInput type="text"
                  [(ngModel)]="lenderRankingFilterBinding"
                  (input)="lenderrankingtbl.filterGlobal($event.target.value, 'contains')" />
                  <button style="float: right;width: 200px;" fmButton type="button" [primary]="true"  fmButton (click)="showAcqnFilterSidebar()" label="Filter"></button>
              </div>
            </ng-template>
            <ng-template fmTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [fmSortableColumn]="col.field" [style.width]="col.width">{{col.header}}
                  <fm-sortIcon [field]="col.field"></fm-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template fmTemplate="body" let-rowData let-columns="columns">
              <tr align="center">
                <td>
                  {{rowData['lenderName']}}
                </td>
                <td>
                  {{rowData['complianceRate'] | percent}}
                </td>
                <td>
                  {{rowData['submissionRate'] | percent}}
                </td>
              </tr>
            </ng-template>
          </fm-table>
        </div>
      </div>
      <br>

</div>